(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["answers-question"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.faq-question').forEach(button => {
  button.addEventListener('click', () => {
    const targetId = button.dataset.target;
    const targetContent = document.getElementById(targetId);

    document.querySelectorAll('.faq-question').forEach(btn => btn.classList.remove('active'));
    document.querySelectorAll('.faq-answer').forEach(ans => ans.classList.remove('active'));

    button.classList.add('active');
    targetContent.classList.add('active');
  });
});

document.querySelectorAll('.faq-mobile-question').forEach(button => {
  button.addEventListener('click', () => {
    const answer = button.nextElementSibling;
    const isActive = button.classList.contains('active');

    document.querySelectorAll('.faq-mobile-question').forEach(btn => btn.classList.remove('active'));
    document.querySelectorAll('.faq-mobile-answer').forEach(ans => ans.classList.remove('active'));

    if (!isActive) {
      button.classList.add('active');
      answer.classList.add('active');
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-recommendation"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".custom-product-recommendation");
  if (!section) return;

  const container = section.querySelector(".custom-product-recommendation-carousel");
  const prevBtn = section.querySelector(".fbt-prev");
  const nextBtn = section.querySelector(".fbt-next");

  const scrollStep = 300;

  const updateArrows = () => {
    if (!container || !prevBtn || !nextBtn) return;
    const atStart = container.scrollLeft <= 0;
    const atEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 1;
    prevBtn.style.opacity = atStart ? "0.3" : "1";
    nextBtn.style.opacity = atEnd ? "0.3" : "1";
  };

  if (nextBtn && prevBtn && container) {
    nextBtn.addEventListener("click", () => {
      container.scrollBy({ left: scrollStep, behavior: "smooth" });
    });
    prevBtn.addEventListener("click", () => {
      container.scrollBy({ left: -scrollStep, behavior: "smooth" });
    });
    container.addEventListener("scroll", updateArrows);
    window.addEventListener("resize", updateArrows);
  }

  updateArrows();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"] && !Shopify.designMode) return;
  try {
    
  const el = document.querySelector('.product-complementary');
  if (el) {
    new IntersectionObserver((entries, obs) => {
      if (!entries[0].isIntersecting) return;
      obs.unobserve(el);
      fetch(el.dataset.url).then(r=>r.text()).then(t=>{
        const d=document.createElement('div'); d.innerHTML=t;
        const r=d.querySelector('.product-complementary');
        if(r&&r.innerHTML.trim()) el.innerHTML=r.innerHTML;
      }).catch(e=>console.error(e));
    }, { rootMargin:'0px 0px 200px 0px' }).observe(el);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-product"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          $('.ltn__related-product-slider-one-active').slick({
              arrows: true,
              dots: false,
              infinite: true,
              speed: 300,
              slidesToScroll: 1,
              prevArrow: '<a class="slick-prev"><i class="fas fa-arrow-left" alt="Arrow Icon"></i></a>',
              nextArrow: '<a class="slick-next"><i class="fas fa-arrow-right" alt="Arrow Icon"></i></a>'
          });
          
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-product2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".frequently-bought-together");
  if (!section) return;

  const container = section.querySelector(".frequently-bought-together-carousel");
  const prevBtn = section.querySelector(".fbt-prev");
  const nextBtn = section.querySelector(".fbt-next");

  const scrollStep = 300;

  const updateArrows = () => {
    if (!container || !prevBtn || !nextBtn) return;
    const atStart = container.scrollLeft <= 0;
    const atEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 1;
    prevBtn.style.opacity = atStart ? "0.3" : "1";
    nextBtn.style.opacity = atEnd ? "0.3" : "1";
  };

  if (nextBtn && prevBtn && container) {
    nextBtn.addEventListener("click", () => {
      container.scrollBy({ left: scrollStep, behavior: "smooth" });
    });
    prevBtn.addEventListener("click", () => {
      container.scrollBy({ left: -scrollStep, behavior: "smooth" });
    });
    container.addEventListener("scroll", updateArrows);
    window.addEventListener("resize", updateArrows);
  }

  const url = section.dataset.url;
  if (url && (!container || container.children.length === 0)) {
    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        const recommendations = div.querySelector(".frequently-bought-together-wrapper");
        if (recommendations) {
          section.appendChild(recommendations);
          const newContainer = section.querySelector(".frequently-bought-together-carousel");
          const newPrev = section.querySelector(".fbt-prev");
          const newNext = section.querySelector(".fbt-next");
          if (newContainer && newPrev && newNext) {
            newNext.addEventListener("click", () => {
              newContainer.scrollBy({ left: scrollStep, behavior: "smooth" });
            });
            newPrev.addEventListener("click", () => {
              newContainer.scrollBy({ left: -scrollStep, behavior: "smooth" });
            });
            newContainer.addEventListener("scroll", updateArrows);
            window.addEventListener("resize", updateArrows);
            updateArrows();
          }
        }
      })
      .catch((err) => console.error("FBT section load failed:", err));
  } else {
    updateArrows();
  }
});

  } catch(e) { console.error(e); }
})();
})();
